module.exports = __webpack_public_path__ + "static/media/basic_user_two.df4e97d6.png";